import React from 'react';
import { compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { Link } from 'react-router-dom';
import CalculatorModal from 'components/CalculatorModal';

class CalculatorLink extends React.Component {
  state = { calculatorModalOpen: false };

  handleOpen = () => this.setState({ calculatorModalOpen: true });
  handleClose = () => this.setState({ calculatorModalOpen: false });

  handleOnClick = (e) => {
    e.preventDefault();
    this.handleOpen();
  };

  render() {
    const { isPrivate, currentUser, geo, ...remainingProps } = this.props;

    return (
      <CalculatorModal
        open={this.state.calculatorModalOpen}
        onClose={this.handleClose}
        currentUser={this.props.currentUser}
        geo={this.props.geo}
      >
        <Link {...remainingProps} onClick={this.handleOnClick} />
      </CalculatorModal>
    );
  }
}

const ACTIVE_CUSTOMS_CATEGORIES = gql`
  query User {
    user {
      acitve_customs_categories {
        id
        name
        name_ar
      }
    }
  }
`;

export default compose(
  graphql(ACTIVE_CUSTOMS_CATEGORIES, {
    options: { fetchPolicy: 'cache-only' },
  })
)(CalculatorLink);



// WEBPACK FOOTER //
// ./app/components/CalculatorLink/index.js